import React, { FC } from 'react';
import { Price } from '../Price';
import { DiscountWrapper, PriceWrapper } from './styles';

import { PriceProps } from '../types';

export const DiscountPrice: FC<PriceProps> = ({
  price,
  noPennies,
  discount,
  className,
  showEach,
  numberOfGuests,
}) => {
  const discountPrice = discount?.discountedPrice;

  return (
    <>
      {price?.amount || price?.amount === 0 ? (
        <PriceWrapper data-cy="wrapper_price" discount={!!discountPrice} className={className}>
          <Price
            data-cy="price"
            price={price}
            noPennies={noPennies}
            numberOfGuests={numberOfGuests}
          />
          {showEach ? <> each</> : null}
        </PriceWrapper>
      ) : null}
      {discountPrice && discountPrice?.amount != price?.amount ? (
        <DiscountWrapper data-cy="wrapper_discount-price">
          <Price
            data-cy="discount-price"
            price={discountPrice}
            noPennies={noPennies}
            numberOfGuests={numberOfGuests}
          />
          {showEach ? <> each</> : null}
        </DiscountWrapper>
      ) : null}
    </>
  );
};
